export default [
  {
    show: true,
    _id: '1063675203',
    name: 'Ngân hàng TMCP Ngoại thương',
    code: 'Vietcombank',
    owner: 'Công ty cổ phần tập đoàn MediaSoft',
    id: '1063675203',
    logo: '/img/payment/vietcombank.png',
    bin: '970436',
  },
  {
    show: false,
    _id: '1036978564',
    name: 'Ngân hàng TMCP Ngoại thương',
    code: 'Vietcombank',
    owner: 'Công ty cổ phần Odii',
    id: '1036978564',
    logo: '/img/payment/vietcombank.png',
    bin: '970436',
  },
  {
    show: false,
    _id: '0381000519086',
    name: 'Ngân hàng TMCP Ngoại thương',
    code: 'Vietcombank',
    owner: 'Nguyễn Thanh Toàn',
    id: '0381000519086',
    logo: '/img/payment/vietcombank.png',
    bin: '970436',
  },
  {
    show: false,
    _id: '11282437',
    name: 'Ngân hàng TMCP Á Châu ',
    code: 'ACB Bank',
    owner: 'Nguyễn Thanh Toàn',
    id: '11282437',
    logo: '/img/payment/acb.png',
    bin: '970416',
  },
  {
    _id: '19036035750016',
    show: false,
    name: 'Ngân hàng TMCP Kỹ thương',
    code: 'Techcombank',
    owner: 'Nguyễn Thanh Toàn',
    id: '19036035750016',
    logo: '/img/payment/techcombank.png',
    bin: '970407',
  },
  {
    show: false,
    _id: '0345197864',
    name: 'Ví điên tử MOMO',
    code: 'MoMo',
    owner: 'Nguyễn Thanh Toàn',
    id: 'momo_0345197864',
    logo: '/img/payment/momo.png',
    bin: '',
  },
  {
    show: false,
    _id: '0345197864',
    name: 'Ví điên tử ZaloPay',
    code: 'ZaloPay',
    owner: 'Nguyễn Thanh Toàn',
    id: 'zalo_0345197864',
    logo: '/img/payment/zalopay.png',
    bin: '',
  },
  {
    show: false,
    _id: '0345197864',
    name: 'Ví điên tử ShopeePay',
    code: 'ShopeePay',
    owner: 'Nguyễn Thanh Toàn',
    id: 'shopeepay_0345197864',
    logo: '/img/payment/shopeepay.png',
    bin: '',
  },
];
